import {useAccessToken} from "../../services/auth"
import React, {useEffect, useState} from "react"
import useAsyncResultIdle from "../../hooks/useAsyncResultIdle"
import {useAsyncResult} from "../../hooks/useAsyncResult"
import {useToasts} from "react-toast-notifications"
import {getByToken, update} from "../../resources/orgSettings"
import Button from "../../components/Button/Button"
import {useRefreshToken} from "../../hooks/useRefreshToken"
import {AsyncResultComponent} from "../../containers/AsyncResult/AsyncResult"

export default function Capital({refresh}: {refresh: () => void}) {
	const accessToken = useAccessToken()
	const [refreshToken, refreshOrgSettings] = useRefreshToken()
	const orgSettingsAsync = useAsyncResult(() => getByToken(accessToken), [refreshToken])

	return (
		<AsyncResultComponent asyncResult={orgSettingsAsync}>
			{({value: orgSettings}) => (
				<CapitalForm
					capitalPageUrl={orgSettings.attributes.capitalSettings?.capitalPageUrl ?? ""}
					refresh={() => {
						refresh()
						refreshOrgSettings()
					}}
				/>
			)}
		</AsyncResultComponent>
	)
}

function CapitalForm({capitalPageUrl: initialValue, refresh}: {capitalPageUrl: string; refresh: () => void}) {
	const accessToken = useAccessToken()
	const [state, patch] = useAsyncResultIdle(update)
	const [capitalPageUrl, setCapitalPageUrl] = useState<string>(initialValue)
	const {addToast} = useToasts()

	useEffect(() => {
		if (state.isOk()) {
			addToast("Capital Settings Updated Successfully", {appearance: "success"})
			refresh()
		}
	}, [state])

	return (
		<div className="card managed-solutions-settings-card">
			<div className="card-content">
				<div className="description">
					The Capital Page URL is the route to the capital page displayed to customers during the servicing phase.
				</div>
				<form
					onSubmit={(e) => {
						e.preventDefault()
						patch(accessToken, {
							capitalSettings: {
								capitalPageUrl: capitalPageUrl === "" ? undefined : capitalPageUrl,
							},
						})
					}}
				>
					<fieldset className="fields">
						<div className="field">
							<label className="label">Capital Page URL (for Capital Orgs only)</label>
							<div className="control">
								<input
									className="input"
									type="url"
									placeholder="Enter URL"
									value={capitalPageUrl}
									onChange={(e) => setCapitalPageUrl(e.target.value)}
								/>
							</div>
						</div>
					</fieldset>
					<div className="columns">
						<div className="column mt-4 button-container">
							{state.match(
								() => (
									<Button className="button primary" type="submit" prefixIcon="approve-v-check-validation">
										Save
									</Button>
								),
								() => (
									<Button className="button primary is-loading">Saving</Button>
								),
								(_) => null,
								(err) => (
									<>
										<div className="has-text-danger">{err.errors[0].title}</div>
										<Button className="button primary" type="submit" prefixIcon="approve-v-check-validation">
											Save
										</Button>
									</>
								)
							)}
						</div>
					</div>
				</form>
			</div>
		</div>
	)
}
